<script lang="ts">
import { defineComponent } from "vue";
import KlereoModal from "@/shared/components/KlereoModal.vue";
import { injectPool } from "@/shared/utils/injection";

export default defineComponent({
  ...injectPool,
  components: { KlereoModal },
  props: {
    showConfirm: Boolean,
    onClose: Function,
  },
  emits: ["close", "next"],
});
</script>

<template>
  <klereo-modal
    :opened="showConfirm"
    :with-close-button="true"
    @close="$emit('close')"
  >
    <div class="mb-5">
      {{ $t("UnsavedChanges") }}
    </div>

    <div class="flex gap-2 justify-end">
      <div
        class="btn--secondary"
        @click="
          $emit('close');
          refreshPool().finally(() => $emit('next'));
        "
      >
        {{ $t("ContinueWithoutSaving") }}
      </div>
      <div
        class="btn--primary"
        @click="
          $emit('close');
          savePool().then(() => $emit('next'));
        "
      >
        {{ $t("SaveAndContinue") }}
      </div>
    </div>
  </klereo-modal>
</template>
